// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DateTimePicker.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DateTimePickerMulti from './Izenda.DateTimePickerMulti';
import DateTimePickerRange from './Izenda.DateTimePickerRange';
import DateTimePickerSingle from './Izenda.DateTimePickerSingle';
import { DATE_TIME_FORMAT, DATE_FORMAT, TIME_FORMAT } from 'logic/data/Izenda.AppGlobalConstants';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import uiState from 'logic/Izenda.UiState';

const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';

@observer
export default class DateTimePicker extends Component {
  static propTypes = {
    time: PropTypes.bool,
    calendar: PropTypes.bool,
    placeholder: PropTypes.string,
    name: PropTypes.string,
    options: PropTypes.object,
    disabled: PropTypes.bool,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    multi: PropTypes.bool,
    hasRange: PropTypes.bool,
    renderInContainer: PropTypes.bool
  };

  static defaultProps = {
    calendar: true,
    time: true,
    multi: false,
    hasRange: false
  };

  // Indicate if the picker is visible
  @observable visible: boolean = false;

  /**
   * Hide picker
   */
  hidePicker = () => {
    this.visible = false;
  };

  /**
   * Show picker
   */
  showPicker = () => {
    this.visible = true;
  };

  /**
   * Get format to store value
   */
  getStoreFormat() {
    const { storeFormat, time } = this.props;
    return typeof storeFormat !== 'undefined' ? storeFormat : !time ? DATE_FORMAT : DATE_TIME_FORMAT;
  }

  componentDidUpdate(prevProps: Object) {
    const { onChange } = this.props;
    if (prevProps.multi && !this.props.multi) {
      onChange && onChange('');
    }
  }

  /**
   * Get format for date time display
   */
  getDisplayFormat() {
    const { displayFormat, calendar, time } = this.props;
    const userDateFormat = uiState.currentUser.dateFormat || DEFAULT_DATE_FORMAT;

    return typeof displayFormat !== 'undefined'
      ? displayFormat
      : calendar === false
      ? TIME_FORMAT
      : time
      ? `${userDateFormat} ${TIME_FORMAT}`
      : userDateFormat;
  }

  /**
   * Get place holder
   */
  getPlaceHolder() {
    return this.props.placeholder || this.getDisplayFormat();
  }

  render() {
    const { multi, hasRange } = this.props;
    const Picker = hasRange ? DateTimePickerRange : multi ? DateTimePickerMulti : DateTimePickerSingle;

    return (
      <Picker
        storeFormat={this.getStoreFormat()}
        displayFormat={this.getDisplayFormat()}
        placeholder={this.getPlaceHolder()}
        visible={this.visible}
        showPicker={this.showPicker}
        hidePicker={this.hidePicker}
        {...this.props}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/DateTime/Izenda.DateTimePicker.js